import { type EmblaCarouselType } from 'embla-carousel';
import { type FC, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';

type Props = {
  className?: string;
  length: number;
  emblaApi?: EmblaCarouselType;
};

function useInit(emblaApi: Props['emblaApi']) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const onDotButtonClick = useCallback(
    (index: number) => {
      if (!emblaApi) return;
      emblaApi.scrollTo(index);
    },
    [emblaApi]
  );

  const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
    setSelectedIndex(emblaApi.selectedScrollSnap());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on('reInit', onSelect).on('select', onSelect);
  }, [emblaApi, onSelect]);

  return {
    selectedIndex,
    onDotButtonClick,
  };
}

export const DotButtons: FC<Props> = ({ className, length, emblaApi }) => {
  const { selectedIndex, onDotButtonClick } = useInit(emblaApi);
  return (
    <Wrapper className={className}>
      {Array.from({ length }, (_, index) => (
        <Button
          className={index === selectedIndex ? 'selected' : ''}
          type="button"
          key={index}
          onClick={() => onDotButtonClick(index)}
        />
      ))}
    </Wrapper>
  );
};

const Button = styled.button`
  cursor: pointer;
  width: 12px;
  height: 12px;
  padding: 0;
  background-color: white;
  border: 1px solid black;
  border-radius: 100%;
  &.selected {
    background-color: black;
  }
`;

const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  justify-content: center;
`;

export default DotButtons;
